import { Injectable } from '@angular/core';
import { BaseApi } from 'app/laas/base-api.service';

@Injectable()
export class AdvancedFilterService {
  constructor(private api: BaseApi) {}

  private filterData: any = {};

  setFilterData(data: any) {
    this.filterData = { ...data };
    sessionStorage.setItem('filters', JSON.stringify(this.filterData));
  }

  getFilterData() {
    return JSON.parse(sessionStorage.getItem('filters'));
  }

  clearFilterData() {
    this.filterData = null;
  }

  getDropDownValues() {
    return this.api.getAll(`/blg/state-zrb-info`);
  }

  getRoleId() {
    return sessionStorage.getItem('getroleId');
  }
}
